const FORMULA_PREFIX = /^[\t\r\n ]*[=+\-@]/;

const escapeCsvValue = value => {
  const stringValue = (value ?? "").toString();
  const escapedValue = typeof value === "string" && FORMULA_PREFIX.test(value) ? `'${stringValue}` : stringValue;

  return `"${escapedValue.replace(/"/g, '""')}"`;
};

export function convertToCSV(data) {
    if (!data?.length) return "";
  
    const headers = Object.keys(data[0]);
    const csvRows = [
      headers.join(","),
      ...data.map(row =>
        headers.map(field => escapeCsvValue(row[field])).join(",")
      )
    ];
    return csvRows.join("\n");
  }
  
  export function downloadCSV(csvContent, filename = "data.csv") {
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
  
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  